import { useRef } from 'react';
export function useRefState(initialState) {
    var state = useRef(initialState);
    var setRefState = function (value) {
        state.current = value;
    };
    return [state.current, setRefState];
}
